import React from "react"

const BGImage = props => {
  const { secBgName, secBgSide } = props

  return (
    <div className={`${secBgSide == "right" ? "bg-image--right" : "bg-image"}`}>
      <img src={secBgName} alt="" />
    </div>
  )
}

export default BGImage
